import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import { neutral, blue } from '../theme/colors';
import { fontFamilies } from '../theme/text';

interface MenuItem {
  /** link url */
  url: string;
  /** displayed text of menu item */
  title: string;
  /** NavLink route matching rule */
  exact: boolean;
}

interface Props {
  /** Array of menu items: { url: string, title: string} */
  menuItems: MenuItem[];
}

const useStyles = makeStyles({
  menu: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    width: '100%',
    borderBottom: `2px solid ${neutral[200]}`,
    margin: 0,
    padding: 0,
    listStyle: 'none'
  },
  link: {
    boxSizing: 'content-box',
    color: neutral[600],
    position: 'relative',
    top: 4,
    padding: 10,
    borderBottom: '4px solid transparent',
    textDecoration: 'none',
    fontWeight: 400,
    fontFamily: fontFamilies.heading,
    fontSize: 16,
    '&:not(:last-of-type)': {
      marginRight: 20
    },
    '&.active': {
      fontWeight: 600,
      borderBottom: `4px solid ${blue[600]}`
    }
  },
  menuItem: {
    margin: 0,
    padding: 0,
    whiteSpace: 'nowrap'
  }
});

/**
 * Component that renders tabbed navigation within a view, supplemental to a primary navigation
 */
const SecondaryNavigation = ({ menuItems }: Props) => {
  const classes = useStyles();
  return (
    <ul className={classes.menu}>
      {menuItems.map((menuItem, index) => (
        <NavLink to={menuItem.url} className={classes.link} key={index} exact={menuItem.exact}>
          <li className={classes.menuItem}>{menuItem.title}</li>
        </NavLink>
      ))}
    </ul>
  );
};

export default SecondaryNavigation;
